@if (formElement(); as element) {
  <hau-form-field [label]="element.field.name"
                  [validation]="element.formControl.errors">

    @if (isMultiControl) {
      <ng-container hauPrefix>
        <nb-icon icon="copy-outline" pack="eva" status="basic" nbTooltip="Mehrfacheingabe"
                 nbTooltipStatus="basic"></nb-icon>
      </ng-container>
    }

    @if (element.fieldDeleted) {
      <ng-container hauPrefix>
        <nb-icon icon="alert-triangle-outline" pack="eva" status="warning"
                 nbTooltip="Dieses Feld wurde gelöscht" nbTooltipStatus="warning"></nb-icon>
      </ng-container>
    }

    @if (element.memberDeleted && !element.fieldDeleted) {
      <ng-container hauPrefix>
        <nb-icon icon="alert-triangle-outline" pack="eva" status="warning"
                 nbTooltip="Dieses Feld wurde aus der Vorlage entfernt" nbTooltipStatus="warning"></nb-icon>
      </ng-container>
    }

    <div class="field-value">
      @if (element.field.composition.cardinalityType === 'Single') {
        <ng-container [ngTemplateOutlet]="single"></ng-container>
      } @else {
        <ng-container [ngTemplateOutlet]="multi"></ng-container>
      }

      @if (element.required) {
        <span class="required-hint">Pflichtfeld</span>
      }
    </div>

    <ng-template #single>
      <ng-container [ngTemplateOutlet]="controlTemplate"
                    [ngTemplateOutletContext]="{control: element.formControl, valueType: element.field.composition.valueType}"></ng-container>
    </ng-template>

    <ng-template #multi>
      @if (formArray; as formArray) {
        <wr-generic-multi-control [formArray]="formArray">
          <ng-template wrControlTemplate let-control="control">
            <ng-container [ngTemplateOutlet]="controlTemplate"
                          [ngTemplateOutletContext]="{control: control, valueType: element.field.composition.valueType}"></ng-container>
          </ng-template>
        </wr-generic-multi-control>
      }
    </ng-template>

    <ng-template #controlTemplate let-control="control" let-valueType="valueType">
      @switch (valueType) {

        @case (ValueTypeEnum.String) {
          <input nbInput fullWidth type="text" [formControl]="asFormControl(control)" placeholder="Kurzer Text" />
        }

        @case (ValueTypeEnum.Integer) {
          <nb-form-field>
            <input nbInput fullWidth type="number" step="1" [formControl]="asFormControl(control)" placeholder="Ganze Zahl" />
            @if (element.field.composition.unit) {
              <span nbSuffix>{{ displayUnit(element.field.composition.unit) }}</span>
            }
          </nb-form-field>
        }

        @case (ValueTypeEnum.Double) {
          <nb-form-field>
            <input nbInput fullWidth type="number" step="0.01" [formControl]="asFormControl(control)" placeholder="Dezimalzahl" />
            @if (element.field.composition.unit) {
              <span nbSuffix>{{ displayUnit(element.field.composition.unit) }}</span>
            }
          </nb-form-field>
        }

        @case (ValueTypeEnum.Boolean) {
          <div class="bool-toggle" [class.bool-disabled]="control.disabled">
            <button nbButton type="button"
                    [status]="control.value === true ? 'success' : 'basic'"
                    [class.active]="control.value === true"
                    (click)="control.setValue(true); control.markAsDirty()">
              <nb-icon icon="checkmark-outline" pack="eva"></nb-icon>
              Ja
            </button>
            <button nbButton type="button"
                    [status]="control.value === false ? 'danger' : 'basic'"
                    [class.active]="control.value === false"
                    (click)="control.setValue(false); control.markAsDirty()">
              <nb-icon icon="close-outline" pack="eva"></nb-icon>
              Nein
            </button>
          </div>
        }

        @case (ValueTypeEnum.Longtext) {
          <textarea nbInput fullWidth [formControl]="asFormControl(control)" placeholder="Langer Text"></textarea>
        }

        @case (ValueTypeEnum.LongtextWithPresets) {
          <textarea nbInput fullWidth [formControl]="asFormControl(control)" placeholder="Langer Text"></textarea>
        }

        @case (ValueTypeEnum.MultipleChoice) {
          <nb-select fullWidth [formControl]="asFormControl(control)" placeholder="Auswahl treffen">
            @for (option of element.field.composition.multipleChoiceOptions; track option) {
              <nb-option [value]="option">
                {{option}}
              </nb-option>
            }
          </nb-select>
        }

        @case (ValueTypeEnum.LocalDate) {
          <input nbInput fullWidth placeholder="Datum wählen"
                 [nbDatepicker]="datePicker"
                 [ngModel]="parseLocalDate(control.value)"
                 (ngModelChange)="onLocalDateChange(control, $event)"
                 [ngModelOptions]="{standalone: true}"
                 [disabled]="control.disabled" />
          <nb-datepicker #datePicker></nb-datepicker>
        }

        @case (ValueTypeEnum.LocalDateTime) {
          <input nbInput fullWidth placeholder="Datum und Uhrzeit wählen"
                 [nbDatepicker]="dateTimePicker"
                 [ngModel]="parseLocalDate(control.value)"
                 (ngModelChange)="onLocalDateTimeChange(control, $event)"
                 [ngModelOptions]="{standalone: true}"
                 [disabled]="control.disabled" />
          <nb-date-timepicker #dateTimePicker withSeconds></nb-date-timepicker>
        }

        @case (ValueTypeEnum.Attachment) {
          <wr-single-attachment-control [formControl]="asFormControl(control)"></wr-single-attachment-control>
        }

        @case (ValueTypeEnum.Table) {
          @if (getTableConfig(element.field.composition); as tableConfig) {
            <wr-table-field
              [control]="asFormControl(control)"
              [config]="tableConfig">
            </wr-table-field>
          }
        }

        @case (ValueTypeEnum.Signature) {
          <wr-signature-field [control]="asFormControl(control)"></wr-signature-field>
        }

      }
    </ng-template>
  </hau-form-field>
}
